/* eslint-disable */
import { getQueryString } from './utils'
import { createApp } from 'vue'
import App from './App.vue'
import carInfo from "./car/id3"
import './index.css'
// const env = import.meta.env.MODE
const dev = 'dev'

const carCode = 'id3' // 车辆代码
const ossUrl = dev ? '' : '' // url 配置

newFontre.initGlobal(carInfo)
// 阻尼效果
// newFontre.orbit.enableCustomDamping = false
// newFontre.orbit.dampingFactor = 0.15

const app = createApp(App)
const env = getQueryString('env')

// 滑动事件
window.onload = () => {
  let startX, startY, endX, endY, distanceX, distanceY;
  const body = document.body
  const COUNT_LIMIT = 2;
  let left_slide_count = 0, right_slide_count = 0;
  let idx = 0

  window.addEventListener('touchstart', e => {
    startX = e.targetTouches[0].pageX;
    startY = e.targetTouches[0].pageY;
    window.parent.postMessage({
      type: "start-move",
      msg: distanceY
    }, "*")
  })
  window.addEventListener('touchmove', e => {
    if (env === 'minip') {
      e.preventDefault(); //阻止默认的处理方式(阻止下拉滑动的效果)
    }

    distanceX = e.targetTouches[0].pageX - startX;
    distanceY = e.targetTouches[0].pageY - startY;
    if (Math.abs(distanceX) < Math.abs(distanceY) && distanceY < 0) {
      // top
      window.parent.postMessage({
        type: "top-move",
        msg: distanceY
      }, "*")
    } else if (Math.abs(distanceX) < Math.abs(distanceY) && distanceY > 0) {
      // down
      window.parent.postMessage({
        type: "down-move",
        msg: distanceY
      }, "*")
    } else {
      // other
      // window.parent.postMessage("stop-move", "*")
    }

  }, { passive: false })

  window.addEventListener('touchend', e => {
    window.parent.postMessage({
      type: "stop-move",
      msg: distanceY
    }, "*")
    distanceY = 0
  })
}

app.mount('#app')







